<div [formGroup]="inputForm" class="flex flex-col justify-start items-start">
  <div>Please provide the Title and Sub-Title to display in the header and footers of your report using the options
    below.
  </div>
  <div class="m-t-20 w-p-100 flex flex-row justify-between items-center">
    <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis">
      <mat-label>Title</mat-label>
      <input formControlName="formReferenceTitle1" matInput placeholder="Title"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="">
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
      <mat-label>Sub-Title</mat-label>
      <input formControlName="formReferenceValue1" matInput placeholder="Sub-Title"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="">
    </mat-form-field>
  </div>
</div>
